(() => {
  const init = () => {
    document.querySelectorAll('[data-password-toggle]').forEach((btn) => {
      const selector = btn.getAttribute('data-target');
      const input = selector ? document.querySelector(selector) : null;
      if (!input) return;

      btn.addEventListener('click', () => {
        const show = input.type === 'password'; // trueなら表示する
        input.type = show ? 'text' : 'password';

        // ★SVG切り替え用
        btn.classList.toggle('is-shown', show);

        // アクセシビリティ
        btn.setAttribute('aria-pressed', show ? 'true' : 'false');
        btn.setAttribute('aria-label', show ? 'パスワードを非表示' : 'パスワードを表示');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();